import React from 'react';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { Select, TimePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import moment from 'moment-timezone';
import './_SueItemUpdate.css';

interface Props {
    sueData: any;
    accidentTime: string | null;
    onDateChange: (field: string, date: Date) => void;
    onBlurTime: (e: any) => void;
    onTimeChange: (time: Dayjs) => void;
    onAccidentDamageParameterChange: (e: any, paramName: string) => void;
    onAccidentDamageSelectChange: (newValue: string, paramName: string) => void;
}

const AccidentDetailsAndPlaceOnCar = (props: Props) => {
    return (
        <div className='white-block white-block-fixed-height'>
            <section className=''>
                <div className='section-sue-title'>
                    פרטי המקרה/תאונה
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך ושעה של מקרה
                            </div>
                            <div className="value rtl">
                                {props.accidentTime && 
                                <TimePicker
                                    variant="borderless"
                                    onChange={props.onTimeChange}
                                    onBlur={props.onBlurTime}
                                    defaultValue={dayjs(props.accidentTime, 'HH:mm')}
                                    value={dayjs(props.accidentTime, 'HH:mm')}
                                    format={'HH:mm'}
                                    // getPopupContainer={(triggerNode: HTMLElement) => triggerNode.parentNode as HTMLElement}
                                    // disabled={!props.sueData.sueAccidentAndDamageInfo}
                                    // needConfirm
                                    popupClassName='time-picker-time-list'
                                />}
                                <CompDatePicker value={props.sueData.sueAccidentAndDamageInfo ? moment(props.sueData.sueAccidentAndDamageInfo.accidentDateTime).toDate() : null} onChange={(date: Date) => props.onDateChange('accidentDateTime', date)} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                האם רשיונך נפסל?
                            </div>
                            <div className="value">
                                <Select
                                    style={{ width: '100%' }}
                                    placeholder=""
                                    value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.isDriverLicensed == 1 ? '1' : '2'}
                                    onChange={(value: string) => props.onAccidentDamageSelectChange(value, 'isDriverLicensed')}
                                    options={
                                        [
                                            {
                                                label: 'כן',
                                                value: '1'
                                            },
                                            {
                                                label: 'לא',
                                                value: '2'
                                            }
                                        ]
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                האם הובא לידיעת משטרה?
                            </div>
                            <div className="value">
                                <Select
                                    style={{ width: '100%' }}
                                    placeholder=""
                                    value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.isPoliceNotified ? '1' : '2'}
                                    onChange={(value: string) => props.onAccidentDamageSelectChange(value, 'isPoliceNotified')}
                                    options={
                                        [
                                            {
                                                label: 'כן',
                                                value: '1'
                                            },
                                            {
                                                label: 'לא',
                                                value: '2'
                                            }
                                        ]
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם התחנה
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.stationName} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'stationName')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מס' יומן/תיק
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.caseNumber} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'caseNumber')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row single-item">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                כתובת מקום ארוע
                            </div>
                            <div className="value">

                                <input type="text" value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.accidentAddress} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'accidentAddress')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="parameter-row single-item">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאור נסיבות המקרה
                            </div>
                            <div className="value">
                                {/* <input type="text" value={sueData.sueAccidentAndDamageInfo && sueData.sueAccidentAndDamageInfo.accidentDetails} onChange={(e:any)=>onAccidentDamageParameterChange(e, 'accidentDetails')} onBlur={(e:any)=>{}} /> */}
                                <textarea className='accidentDetails 2' value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.accidentDetails} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'accidentDetails')} onBlur={(e: any) => { }} />
                                {/* <pre>
                                        {JSON.stringify(sueData.sueAccidentAndDamageInfo, null, 2)}
                                    </pre> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='with-top-border'>
                <div className='section-sue-title'>
                    נזקים
                </div>
                <div className="parameter-row single-item">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאור הנזקים ברכב המבוטח
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.insuredCarDamageDescription} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'insuredCarDamageDescription')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row single-item">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאור הנזקים צד ג'
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueAccidentAndDamageInfo && props.sueData.sueAccidentAndDamageInfo.thirdPartyCarDamageDescription} onChange={(e: any) => props.onAccidentDamageParameterChange(e, 'thirdPartyCarDamageDescription')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AccidentDetailsAndPlaceOnCar